import * as React from 'react'
import { UNSAFE_NavigationContext } from 'react-router-dom'
import type { History } from 'history'

const useBlocker = (blocker: any, when = true): void => {
  const navigator = React.useContext(UNSAFE_NavigationContext).navigator as History
  React.useEffect(() => {
    if (!when) return

    const push = navigator.push
    navigator.push = (...args: Parameters<typeof push>) => {
      const result = blocker({ location: args[0] })
      if (result !== false) {
        push(...args)
      }
    }
    return () => {
      navigator.push = push
    }
  }, [navigator, blocker, when])
}

export default useBlocker
